import React, { useState } from "react";
import PropTypes from "prop-types";
//
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ButtonMain from "../../../../../common/components/button/ButtonMain";
import CommonListItem from "./CommonListItem";
//
// eslint-disable-next-line import/named
import { isFunction } from "../../../../../common/utils";

const PopupChoose = ({
  options,
  title,
  submitText,
  onSubmit,
  disabledBtn,
  withGoBack,
  onGoBack,
  withNextStep,
  onNextStep,
}) => {
  const [localOptions, setLocalOptions] = useState(
    (options || []).map((opt) => ({
      ...opt,
      checked:
        opt.checked === false || opt.checked === true ? opt.checked : false,
    }))
  );
  const parentDisabledBtn = isFunction(disabledBtn)
    ? disabledBtn(localOptions)
    : disabledBtn;
  const leastOneChecked =
    parentDisabledBtn && localOptions.filter((opt) => opt.checked).length > 0;
  const localDisabledBtn = !leastOneChecked;

  const onCheckboxChange = (opt) => (e) => {
    const { checked } = e.target;
    const newOpt = [];
    localOptions.forEach((localOpt) => {
      if (localOpt.id === opt.id) {
        newOpt.push({
          ...localOpt,
          checked,
        });
      } else {
        newOpt.push(localOpt);
      }
    });
    setLocalOptions(newOpt);
  };

  return (
    <Box py={1} px={1}>
      {(withGoBack || withNextStep) && (
        <Box mb={2} display="flex" justifyContent="space-between">
          {withGoBack && (
            <IconButton
              aria-label="go back"
              onClick={(e) => {
                if (onGoBack) onGoBack(e);
              }}
            >
              <ArrowLeftIcon />
            </IconButton>
          )}
          {withNextStep && (
            <IconButton
              aria-label="go next"
              onClick={(e) => {
                if (onNextStep) onNextStep(e);
              }}
            >
              <ArrowRightIcon />
            </IconButton>
          )}
        </Box>
      )}
      {title && (
        <Box mb={2} minWidth={200}>
          <Typography variant="body2">{title}</Typography>
        </Box>
      )}
      <Box px={2} pt={1} pb={1} minWidth={222}>
        {Array.isArray(localOptions) &&
          localOptions.map((opt, idx) => (
            <CommonListItem
              key={idx.toString()}
              checked={opt.checked}
              withCheckbox
              onCheckboxChange={onCheckboxChange(opt)}
              context={{ ...opt, textPrimary: opt.displayName }}
              withAvatar
              avatarSize="small"
              darkMode={false}
            />
          ))}
      </Box>
      {submitText && (
        <Box px={2} pb={1} minWidth={222}>
          <ButtonMain
            buttonProps={{
              text: submitText,
              fullWidth: true,
              onClick: (e) =>
                onSubmit(
                  e,
                  localOptions.filter((opt) => opt.checked)
                ),
              disabled: localDisabledBtn,
              variant: localDisabledBtn ? "disabled" : null,
            }}
          />
        </Box>
      )}
    </Box>
  );
};

PopupChoose.propTypes = {
  options: PropTypes.arrayOf(PropTypes.any),
  title: PropTypes.string,
  submitText: PropTypes.string,
  onSubmit: PropTypes.func,
  disabledBtn: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  withGoBack: PropTypes.bool,
  onGoBack: PropTypes.func,
  withNextStep: PropTypes.bool,
  onNextStep: PropTypes.func,
};

PopupChoose.defaultProps = {
  options: [],
  title: null,
  submitText: null,
  onSubmit: () => null,
  disabledBtn: false,
  withGoBack: false,
  onGoBack: () => null,
  withNextStep: false,
  onNextStep: () => null,
};

export default PopupChoose;
